import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class SubdivisionModule {
    constructor() {
        this.subdivisions = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(subdivision) {
        this.subdivisions = subdivision;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.subdivisions;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.subdivision.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(subdivision) {
        try {
            await service.subdivision.add(subdivision);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(subdivision) {
        try {
            await service.subdivision.edit(subdivision);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(payloads) {
        try {
            const { id, confirm = false, } = payloads;
            await service.subdivision.delete(id, confirm);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], SubdivisionModule.prototype, "subdivisions", void 0);
__decorate([
    State()
], SubdivisionModule.prototype, "count", void 0);
__decorate([
    State()
], SubdivisionModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], SubdivisionModule.prototype, "setItems", null);
__decorate([
    Mutation()
], SubdivisionModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], SubdivisionModule.prototype, "setError", null);
__decorate([
    Getter()
], SubdivisionModule.prototype, "list", null);
__decorate([
    Getter()
], SubdivisionModule.prototype, "total", null);
__decorate([
    Getter()
], SubdivisionModule.prototype, "errorList", null);
__decorate([
    Action()
], SubdivisionModule.prototype, "get", null);
__decorate([
    Action()
], SubdivisionModule.prototype, "add", null);
__decorate([
    Action()
], SubdivisionModule.prototype, "edit", null);
__decorate([
    Action()
], SubdivisionModule.prototype, "delete", null);
